import { IFullPageData } from "@pageBuilder/typings";

export class DocumentUtil {

    public static getPageStructure(doc: Document): IFullPageData| null {
        const structureAttributeData = doc.documentElement.getAttribute("data-page-structure");
        return structureAttributeData ? JSON.parse(structureAttributeData) as IFullPageData : null;
    }

}